import { useRef } from 'react';

export const HorizontalScroller = ({ children, width }: { children: React.ReactNode; width: number }) => {
  const topScrollbarRef = useRef<HTMLDivElement | null>(null);
  const contentRef = useRef<HTMLDivElement | null>(null);

  // Synchronize the scroll position of the top and bottom scrollbars
  const syncScroll = (source: string) => {
    if (contentRef.current && topScrollbarRef.current) {
      if (source === 'top') {
        contentRef.current.scrollLeft = topScrollbarRef.current.scrollLeft;
      } else if (source === 'content') {
        topScrollbarRef.current.scrollLeft = contentRef.current.scrollLeft;
      }
    }
  };

  return (
    <div className="scroll-table-container">
      <div className="top-horizontal-scroll-container" onScroll={() => syncScroll('top')} ref={topScrollbarRef}>
        <div className="top-horizontal-scroll" style={{ width: `${width}px` }}></div>
      </div>
      <div className="main_content_container" ref={contentRef} onScroll={() => syncScroll('content')}>
        <div className="children__content">{children}</div>
      </div>
    </div>
  );
};
